"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var configs_1 = require("./configs");
var style_1 = require("./style");
var InputButton = /** @class */ (function (_super) {
    __extends(InputButton, _super);
    function InputButton(props) {
        var _this = _super.call(this, props) || this;
        _this.captureClickEvent = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        _this.handleOnClick = function (event) {
            var _a = _this.props, isControlled = _a.isControlled, isDisabled = _a.isDisabled, onInputClick = _a.onInputClick;
            if (isDisabled) {
                return _this.captureClickEvent(event);
            }
            if (!isControlled) {
                _this.setState({ isInputActive: !_this.state.isInputActive });
            }
            /* @! Strongly slows down the entire component when set to onClick */
            if (onInputClick !== undefined) {
                onInputClick();
            }
        };
        _this.handleRightIconClick = function (event) {
            var _a = _this.props, isDisabled = _a.isDisabled, onRightIconClick = _a.onRightIconClick, shouldRightIconClickStopPropagation = _a.shouldRightIconClickStopPropagation;
            if (isDisabled) {
                return _this.captureClickEvent(event);
            }
            if (onRightIconClick !== undefined) {
                if (shouldRightIconClickStopPropagation) {
                    _this.captureClickEvent(event);
                }
                onRightIconClick();
            }
        };
        _this.state = {
            isInputActive: (props.isControlled && !props.isDisabled)
                ? props.isActive
                : false
        };
        return _this;
    }
    InputButton.prototype.componentDidUpdate = function (prevProps) {
        if (!this.props.isDisabled &&
            this.props.isControlled &&
            this.props.isActive !== prevProps.isActive &&
            this.props.isActive !== this.state.isInputActive) {
            this.setState({ isInputActive: this.props.isActive });
        }
    };
    InputButton.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, isControlled = _a.isControlled, isDisabled = _a.isDisabled, leftIconVariant = _a.leftIconVariant, rightActiveIconVariant = _a.rightActiveIconVariant, rightInactiveIconVariant = _a.rightInactiveIconVariant;
        var isInputActive = this.state.isInputActive;
        var isActive = (isControlled) ? isInputActive : this.props.isActive;
        var rightIconVariant = rightActiveIconVariant !== undefined && isActive
            ? rightActiveIconVariant
            : rightInactiveIconVariant !== undefined && !isActive
                ? rightInactiveIconVariant
                : undefined;
        var RightIcon = rightIconVariant !== undefined ? configs_1.rightIcons[rightIconVariant] : undefined;
        var LeftIcon = leftIconVariant !== undefined ? configs_1.leftIcons[leftIconVariant] : undefined;
        return (react_1.default.createElement(style_1.Wrapper, { className: className, isActive: isActive, isDisabled: isDisabled },
            react_1.default.createElement(style_1.ContentWrapper, { isDisabled: isDisabled, onClick: this.handleOnClick },
                leftIconVariant !== undefined ? (react_1.default.createElement("div", { className: 'InputButton_elementIcon InputButton_leftIcon' }, LeftIcon !== undefined ? (react_1.default.createElement(LeftIcon, null)) : null)) : null,
                react_1.default.createElement("div", { className: 'InputButton_wrapperContent' }, children),
                rightIconVariant !== undefined ? (react_1.default.createElement("div", { className: 'InputButton_elementIcon InputButton_rightIcon' }, RightIcon !== undefined ? (react_1.default.createElement("span", { className: 'InputButton_elementIconSVG', onClick: this.handleRightIconClick },
                    react_1.default.createElement(RightIcon, null))) : null)) : null)));
    };
    InputButton.defaultProps = {
        isActive: false,
        isControlled: true,
        isDisabled: false,
        shouldRightIconClickStopPropagation: true
    };
    return InputButton;
}(react_1.default.Component));
exports.default = InputButton;
